import { Icon } from '@/components';

export type CredentialsFormFields = {
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
};

export function ShowPassword({ showPassword, setShowPassword }: CredentialsFormFields) {
  return (
    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      className="absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer text-gray-500 hover:text-gray-700"
    >
      {showPassword ? <Icon name="eye-open" className="h-5 w-5" /> : <Icon name="eye-off" className="h-5 w-5" />}
    </button>
  );
}
